import { render, staticRenderFns } from "./a-payment.vue?vue&type=template&id=71ee37f2&"
import script from "./a-payment.vue?vue&type=script&lang=js&"
export * from "./a-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports